<script>
  import {mapGetters} from 'vuex';
  import {Pie} from "vue-chartjs";
  import ChartMixin from '@/mixins/charts';

  export default {
    extends: Pie,
    mixins: [ChartMixin],
    props: {
      chartdata: {
        required: true,
      },
      options: {
        required: true,
      },
      width: {
        required: false,
      },
      height: {
        required: false,
      },
    },
    computed: {
      ...mapGetters({
        chartColors: 'helper/getChartColors'
      }),
    },
    mounted() {
      this.chartdata.datasets.forEach(dataset => {
        dataset.backgroundColor = this.generateColors(dataset)
      });

      this.options.tooltips = {
          callbacks: {
            label: (item, data) => {
              let label = data.labels[item.index]+': '+data.datasets[item.datasetIndex].label;
              let value = data.datasets[item.datasetIndex].data[item.index];
              let field = data.datasets[item.datasetIndex].field;

              if(field.includes('currency')) {
                return label + ': $ ' + value.toFixed(2);
              }

              return label + ': ' + value;
            }
          }
      }

      this.options.legend = {
        display: true,
        labels: {
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;
            return datasets[0].data.map((data, i) => ({
              text: `${chart.data.labels[i]} (${data})`,
              fillStyle: datasets[0].backgroundColor[i],
              index: i
            }))
          }
        }
      }

      // this sets white background when printing chart
      this.addBackgroundPlugin(this);

      this.renderChart(this.chartdata, this.options)
    },
    methods: {
      generateColors(dataset) {
        let colors = [];
        let i = 0;
        while(dataset.data.length > colors.length) {
          i++;
          colors.push(this.chartColors[i % this.chartColors.length ])
        }
        return colors;
      }
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// PieChart.vue?0450a113